import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=70f7fcfe&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f7fcfe')) {
      api.createRecord('70f7fcfe', component.options)
    } else {
      api.reload('70f7fcfe', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=70f7fcfe&", function () {
      api.rerender('70f7fcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4PRIFhd3IBv0r/JS/offershelp.vue"
export default component.exports